import moment from 'moment-timezone';
import styles from './styles';
import {Platform, View, TextInput, StyleSheet, Text} from 'react-native';
import AndroidDatePicker from '~components/DatePicker/AndroidDatePicker';
import AndroidTimePicker from '../DateTimeModal/AndroidTimePicker';
import {useTheme} from '~contexts/ThemeContext';
import {useState, useEffect} from 'react';

// Only import react-native-date-picker on native platforms
let DatePicker: any = null;
if (Platform.OS !== 'web') {
  DatePicker = require('react-native-date-picker').default;
}

// Import web date picker for web platform
let WebDatePicker: any = null;
if (Platform.OS === 'web') {
  WebDatePicker = require('~components/WebDatePicker/WebDatePicker').default;
}

interface IProps {
  handleChooseDate: (value?: Date) => void;
  date?: Date;
  mixAvailableDate?: Date;
  maxAvailableDate?: Date;
  withoutMaxAvailableDate?: boolean;
  mode?: 'date' | 'time' | 'datetime';
}

const isAndroid = Platform.OS === 'android';
const isWeb = Platform.OS === 'web';

const OneDatePicker = ({
  handleChooseDate,
  date,
  withoutMaxAvailableDate = false,
  mixAvailableDate,
  maxAvailableDate,
  mode = 'date',
}: IProps) => {
  const {colors} = useTheme();
  const currentDate = date || moment().toDate();
  const [displayValue, setDisplayValue] = useState(moment(currentDate).format('YYYY-MM-DD'));

  useEffect(() => {
    setDisplayValue(moment(currentDate).format('YYYY-MM-DD'));
  }, [currentDate]);

  // Web implementation
  if (isWeb) {
    const handleDateChange = (newDate: Date) => {
      setDisplayValue(moment(newDate).format('YYYY-MM-DD'));
      handleChooseDate(newDate);
    };

    if (!WebDatePicker) {
      // Fallback if WebDatePicker couldn't load
      return (
        <View>
          <Text>Date picker not available</Text>
        </View>
      );
    }

    return (
      <WebDatePicker
        value={currentDate}
        onChange={handleDateChange}
        minDate={mixAvailableDate}
        maxDate={withoutMaxAvailableDate ? undefined : maxAvailableDate || moment().toDate()}
        colors={colors}
        placeholder="YYYY-MM-DD"
      />
    );
  }

  return (
    <>
      {false ? (
        <>
          {mode === 'date' ? (
            <AndroidDatePicker
              date={currentDate}
              onDateChange={handleChooseDate}
              minimumDate={mixAvailableDate}
              maximumDate={withoutMaxAvailableDate ? undefined : maxAvailableDate || moment().toDate()}
            />
          ) : (
            <AndroidTimePicker time={currentDate} onTimeChange={handleChooseDate} />
          )}
        </>
      ) : (
        <DatePicker
          style={styles.container}
          locale="en-US"
          testID="dateTimeGPicker"
          textColor={colors.black}
          date={currentDate}
          onDateChange={handleChooseDate}
          minimumDate={mixAvailableDate}
          maximumDate={withoutMaxAvailableDate ? undefined : maxAvailableDate || moment().toDate()}
          mode={mode}
        />
      )}
    </>
  );
};

export default OneDatePicker;
